<template>
  <div class="edit__wrap">
    <component v-for="item in viewData.inputs"
               :is="item.component"
               :name="item.name"
               :key="item.name"
               :label="item.label"
               v-validate="item.rules"
               v-model="data[item.name]"
               :error="errors.first(item.name)"
    />
  </div>
</template>

<script>
  import editMixin from '../../mixins/editMixin';
  import InputText from '../../components/inputs/InputText';
  import InputTextarea from '../../components/inputs/InputTextarea';
  export default {
    name: "EditInputs",
    components: {InputTextarea, InputText},
    mixins: [editMixin]
  }
</script>

<style scoped>

</style>